<template>
  <div>
    <template v-if="!getTextModel">
      <el-input
        v-model.trim="form[item.bind]"
        v-bind="item"
        :required="false"
        @change="
          (val) => {
            item.change
              ? item.change(val, item)
              : item.focus && item.focus(val, item);
          }
        "
        @focus="
          (val) => {
            item.focus && item.focus(val, item);
          }
        "
        @blur="
          (val) => {
            item.blur && item.blur(val, item);
          }
        "
      >
        <el-button
          :slot="item.append ? 'append' : false"
          :icon="item.icon ? item.icon : 'el-icon-search'"
          @click="item.click ? item.click(item) : callFn(item, $event)"
        ></el-button>
        <template :slot="item.prepend ? 'prepend' : false">{{
          item.prependStr
        }}</template>
      </el-input>
    </template>
    <div v-else>
      {{ form[item.bind] }}
    </div>
  </div>
</template>

<script>
export default {
  name: "FormItemInput",
  props: {
    item: {
      type: Object,
      default: () => ({}),
    },
    form: {
      type: Object,
      default: () => ({}),
    },
    formComConfig: {
      type: Object,
      default: () => ({}),
    },
    callFn: {
      type: Function
    }
  },
  computed: {
    // 是否采用文字模式
    getTextModel() {
      if (undefined === this.item.isText || '' === this.item.isText) {
        // item没有设置是否纯文本显示，判断全局的textModel
        return this.formComConfig.textModel;
      } else {
        return this.item.isText;
      }
    },
  },
};
</script>

<style>
</style>


// WEBPACK FOOTER //
// packages/SrAdd/components/form-item-input.vue